import React, { useEffect, useState } from "react";
import { httpReauest } from "../utils/httpRequest";
import UserTasks from "../components/layout/UserTasks";
import { getUser } from "../api/getUser";
import EventTimerCard from "../components/common/cards/EventTimerCard";

const TasksPage = () => {
  const [data, setdata] = useState();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    getData();
    // getEvent();
  }, []);

  async function getData() {
    const user = JSON.parse(localStorage.getItem("user"));
    const res = await getUser(user._id);
    setdata(res);
  }

  async function getEvent() {
    const res = await httpReauest("GET", "/user/event");
    setEvent(res.data?.data);
  }

  return (
    <div className="w-full py-6 text-white">
      {event?.end_time && <EventTimerCard event={event} user={data} />}
      <UserTasks data={data} />
    </div>
  );
};

export default TasksPage;
